
import type {
  ObjectConfigFieldData,
  ObjectConfigFieldSchema,
} from '@empathyco/playboard-core-domain'
import type { PropType } from 'vue'

import { ConfigFieldVisibilityEnum } from '@empathyco/playboard-core-domain'

import { defineComponent } from 'vue'

import { InstanceManagementUtils } from '../../utils'

import InputLabel from '../shared/input-label.component.vue'

export default defineComponent({
  name: 'ObjectServiceConfigField',
  components: {
    InputLabel,
  },
  props: {
    label: {
      type: String,
    },
    description: {
      type: String,
    },
    value: {
      type: Object as PropType<ObjectConfigFieldData>,
      default: () => ({}),
    },
    schema: {
      type: Object as PropType<ObjectConfigFieldSchema>,
      required: true,
    },
    required: {
      type: Boolean,
    },
    readonly: {
      type: Boolean,
    },
    level: {
      type: Number,
    },
  },
  data(): Record<string, any> {
    return {
      baseClass: 'epb-object-service-config-field',
    }
  },
  computed: {
    visiblePropertyIds(): string[] {
      return InstanceManagementUtils.getObjectServiceConfigFieldVisiblePropertyIds(this.schema)
    },
  },
  methods: {
    isPropertyRequired(id: string): boolean {
      return this.schema.required?.includes(id) ?? false
    },
    isPropertyReadonly(id: string): boolean {
      if (this.readonly) {
        return true
      }
      return (
        this.schema.properties[id].front_metadata?.visibility === ConfigFieldVisibilityEnum.READONLY
      )
    },
  },
})
